module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/airpods-8fdb1e46ab1d7b4b72e980a151323033.svg";